import React from 'react';
import styled, { StylesProps } from '../../../../lib/styles';
import { compose } from 'recompose';

import blockStyles from './Block_styles';
import Spacer from '../../../../components/presentational/Spacer';
import Ad, { Ads } from '../../../../components/presentational/Ad';

export interface AdBlockData {
  type: 'ad_block';
  position: 'top' | 'bottom';
}

interface AdBlockProps {
  block: AdBlockData;
  blockIndex: number;
  ads: Ads;
}

const AdBlock = ({
  blockIndex,
  block: { position },
  styles,
  ads: { top, bottom },
}: AdBlockProps & StylesProps<typeof blockStyles>) => (
  <div className={styles.container}>
    <Spacer width={1160} space={['m', 'l']}>
      {position === 'top' && top && (
        <Ad
          ad={top}
          adIDSuffix={blockIndex.toString()}
          lazy
          initialSize={[300, 90]}
        />
      )}
      {position === 'bottom' && bottom && (
        <Ad
          ad={bottom}
          adIDSuffix={blockIndex.toString()}
          lazy
          initialSize={[300, 90]}
        />
      )}
    </Spacer>
  </div>
);

export default compose(styled(blockStyles))(AdBlock);
